import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
    <Navbar/>
    <Hero/>
    <Skills/>
    <About/>
    <Projects/>
    <Contact />
    <Footer />
    </>
  );
}

export default App;
